
import { defineComponent, SetupContext, getCurrentInstance, onUnmounted, watch, onMounted, ref, reactive, computed } from 'vue';
import { formateNum, formateTime, handleCommentReg, openNewWindow } from '@/common/utils'
import Load from './loading.vue'
import { sendLog } from '~/common/radar';
import ActionPopover from '@/components/ActionPopover/index.vue';

export default defineComponent({
  components: {
    Load,
    ActionPopover
  },
  props: {
    commentsList: {
        type: Array,
        default: []
    },
    cursorSubComment: {
        type: Object,
        default: {}
    },
  },
  setup(props, ctx: SetupContext) {
    const { proxy } = getCurrentInstance() as any
    const isSnack = proxy.$store.state.isSnack


    //保存所有主评论的子评论个数
    const subCommentCountInRoot=ref<any>({})
    const isHasMoreComments=ref<boolean>(true)

    const getMoreSubComments = (id: string) => {
        sendLog({
            type: 'click',
            name: 'COMMENT_AREA',
            value: {
                button_type: 'expand'
            }
        })
        ctx.emit('getMoreSubComments', id)
    }
    
    const handleClick = (type: string, kwaiId?: string) => {
        if(type=='photo' || type === 'name') {
            openNewWindow(`/@${kwaiId}?page_source=detail`)
        } else ctx.emit('showModal', type)
    }

    const getReportActions = (commentId: string | number) => {
        if (proxy.$store.state.startup.bucket !== 'br') return [];
        return [{
            type: 'report',
            payload: {
                source: 2,
                linkId: commentId
            }
        }];
    }

    const isBrBucket = computed(() => proxy.$store.state.startup.bucket === 'br');

    onMounted( () => {
    })

    return {
        isSnack,
        formateNum,
        handleClick,
        formateTime,
        isHasMoreComments,
        subCommentCountInRoot,
        getMoreSubComments,
        handleCommentReg,
        getReportActions,
        isBrBucket,
    }
  },
})
